import React from 'react'
import { useTranslation } from 'react-i18next'
import { ICellRendererParams } from 'ag-grid-enterprise'
import ScenarioName from '../../../../../features/scenario/components/ScenarioName'
import { DropdownCellLayout } from './CellComponents'

interface ScenarioCascaderRendererParams {
  companyId?: string
}

export const ScenarioCascaderRenderer: React.FC<ICellRendererParams> = ({ value, colDef }) => {
  const { t } = useTranslation()
  const params = (colDef?.cellEditorParams || {}) as ScenarioCascaderRendererParams
  const { companyId } = params

  const renderValue = () => {
    if (!value) return ''

    if (Array.isArray(value)) {
      const dataType = value[0]
      if (!dataType) return ''

      const translated = t(`global:${dataType}`)

      if (value.length === 1) return translated

      const scenarioId = value[1]
      if (scenarioId && companyId) {
        return (
          <>
            {translated} / <ScenarioName companyId={companyId} scenarioId={scenarioId} />
          </>
        )
      }

      return `${translated} / ${scenarioId || ''}`
    }

    return t(`global:${value}`)
  }

  return <DropdownCellLayout>{renderValue()}</DropdownCellLayout>
}
